import styled from "styled-components";

export const BaseItemStyles = styled.li`
  overflow: hidden;
  text-align: left;
  line-height: 1.1;
  font-size: var(--small-font-size);
  border-bottom: 1px solid var(--gallery);
  color: var(--tudora);

  a {
    display: block;
    padding: var(--md);
    text-decoration: none;
    background: var(--white);

    &:hover {
      background: var(--foam);
    }
  }
`;
